import React from 'react';
import { SectionCard } from '../common/SectionCard';
import { cn } from '../../utils/cn';
import type { CampaignEntry, ChannelState } from '../../types/outreach';
const stateClasses: Record<ChannelState, string> = {
  queued: 'bg-muted text-muted-foreground',
  scheduled: 'bg-uae-gold/18 text-uae-bronze',
  live: 'bg-uae-leaf text-white',
  delivered: 'bg-uae-green text-white'
};
const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export function CampaignCalendar({
  entries
}: {
  entries: CampaignEntry[];
}) {
  const days = Array.from({
    length: 28
  }, (_, index) => index + 1);
  return <SectionCard title="Campaign calendar" description="Distribution activity across the first four weeks of the campaign window." data-id="element-1023" data-mp="30hi1xborofjy">
      <div className="grid grid-cols-7 gap-1.5" data-id="element-1024" data-mp="2vlau1dct8tzd">
        {weekdays.map(day => <p key={day} className="pb-1 text-center text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground" data-id="element-1025" data-mp="1p4flqhqkxs0b">
            {day}
          </p>)}
        {days.map(day => {
        const dayEntries = entries.filter(entry => entry.day === day);
        return <div key={day} className="min-h-[74px] rounded-sm border border-border bg-background p-1.5" data-id="element-1026" data-mp="32lr3jslv09a">
              <p className="font-mono text-[10px] text-muted-foreground" data-id="element-1027" data-mp="80dh289owcau">
                {String(day).padStart(2, '0')}
              </p>
              <div className="mt-1 space-y-1" data-id="element-1028" data-mp="3qdtfligm9vg3">
                {dayEntries.map(entry => <p key={entry.id} className={cn('truncate rounded-sm px-1 py-0.5 text-[10px] leading-tight', stateClasses[entry.state])} title={`${entry.label} — ${entry.partner}`} data-id="element-1029" data-mp="3v87gu1hymwso">
                    {entry.label}
                  </p>)}
              </div>
            </div>;
      })}
      </div>
      <ul className="mt-3 flex flex-wrap gap-3" data-id="element-1030" data-mp="1i197bywuzr6k">
        {(Object.keys(stateClasses) as ChannelState[]).map(state => <li key={state} className="flex items-center gap-1.5 text-[11px] text-muted-foreground" data-id="element-1031" data-mp="1d6v8tnmwh3xo">
            <span className={cn('h-2.5 w-2.5 rounded-sm', stateClasses[state])} aria-hidden="true" data-id="element-1032" data-mp="187sfv1k72o62" />
            <span className="capitalize" data-id="element-1033" data-mp="20z27wuk0fp0s">{state}</span>
          </li>)}
      </ul>
    </SectionCard>;
}